import React from 'react';

import { get } from 'lodash';

import AgentStatus from '../../components/AgentStatus';
import SidebarPanel from '../../components/SidebarPanel';
import BOBDate from '../../components/BOBDate';
import classes from './AgentInformationPanel.module.css';

const ErpAgentInformationPanel = ({agent}) => (
    <SidebarPanel
        title="FSM Integration Information"
        titleIconSrc="/assets/images/erpAgentIconColor.svg"
    >
        <dl className={classes.agentInfo}>
            <dt>Serial Number</dt>
            <dd>{agent.agentSerial}</dd>

            <dt>Connection Status</dt>
            <dd><AgentStatus agent={agent} showLabel /></dd>

            <dt>Worker Status</dt>
            <dd>{agent.workerStatus}</dd>

            <dt>Software Version</dt>
            <dd>{agent.softwareVersion}</dd>

            <dt>FSM Driver</dt>
            <dd>{agent.agentType}</dd>

            <dt>FSM Database(s)</dt>
            <dd>{agent.databaseName}</dd>

            <BOBDate
                date={get(agent, 'latestSync')}
                render={latestSync => (
                    <>
                        <dt>Latest FSM Sync</dt>
                        <dd>{latestSync}</dd>
                    </>
                )}
            />
        </dl>
    </SidebarPanel>
);

export default ErpAgentInformationPanel;
